import { saveAs } from 'file-saver';
import * as SearchRepo from '@/repository/search';
import * as EntityRepo from '@/repository/entity';
import type { Router } from 'vue-router';
import type { Upload } from '@fibl/oxs-common';
import { toLocale } from './global-props';

export function base64EncodeFile(file: Blob) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});
}

export function base64DecodeFile(encodedFile: string, fileName: string) {
	const start = encodedFile.indexOf(',');
	let mimeType;
	let data;
	let base64 = false;
	let decoded;
	if (start > 0) {
		let prefix = encodedFile.substring(0, start);
		let m = prefix.match(/^data:(\w+\/[-+.\w]+)(;base64)?$/);
		console.log('match', prefix, m);
		if (m) {
			base64 = !!m[2];
			mimeType = m[1];
		}
		data = encodedFile.substring(start+1)
	} else {
		data = encodedFile;
	}
	if (base64) {
		decoded = atob(data);
	} else {
		decoded = data;
	}
	const bits = new Uint8Array(decoded.length);

	for (let i = 0; i < decoded.length; i++) {
		bits[i] = decoded.charCodeAt(i);
	}

	const options = { type: '' };
	if (mimeType) {
		options.type = mimeType;
	}

	return new File([bits], fileName, options);
}

export function dataUriToBlob(dataURI: string) {
	// convert base64 to raw binary data held in a string
	// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	let mime = 'application/octet-stream';
	let content;
	if (dataURI.substring(0, 5) === 'data:') {
		const match = dataURI.match(/^data:(?<mime>[\w/\-.]+)(;(?<encoding>\w+))?,(?<data>.*$)/s);
		if (!match) throw new Error('invalid data uri');
		content =
			match.groups!.encoding === 'base64' ? atob(match.groups!.data) : match.groups!.data;
		mime = match.groups!.mime;
	} else {
		content = dataURI;
	}
	// write the bytes of the string to an ArrayBuffer
	const ab = new ArrayBuffer(content.length);
	// create a view into the buffer
	const ia = new Uint8Array(ab);
	// set the bytes of the buffer to the correct values
	for (let i = 0; i < content.length; i++) {
		ia[i] = content.charCodeAt(i);
	}
	// write the ArrayBuffer to a blob, and you're done
	const blob = new Blob([ab], { type: mime });
	return blob;
}

export function downloadUpload(blob: Blob, name: string) {
	try {
		!!new Blob();
	} catch (e) {
		console.log('no save support', e);
		return;
	}
	saveAs(blob, name);
}

const idRegexp =
	/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/u;

export async function downloadFromRoute($route: { hash?: string }, $router: Router) {
	const { hash } = $route;
	// console.log('downloadFromRoute', $route);
	if (!hash || hash.substring(0, 10) !== '#download=') return;
	const downloadId = hash.substring(10);
	const newRoute = { ...$route };
	delete newRoute.hash;
	$router.replace(newRoute);
	await downloadFromId(downloadId);
}

export async function downloadFromId(downloadId: string) {
	if (!idRegexp.test(downloadId)) return;
	const dlEnt = await SearchRepo.getEntityById<Upload.Upload>(downloadId);
	const name = toLocale(dlEnt.data.name).replace(/[^a-z0-9_. -]+/gi, '');
	const attachment = await EntityRepo.getAttachment(downloadId);
	const blob = base64DecodeFile(attachment, name);
	downloadUpload(blob, name);
}
